package ir.yusefpasha.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import ir.yusefpasha.models.Achievement
import ir.yusefpasha.models.Theme
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun AchievementCard(
    modifier: Modifier = Modifier,
    achievement: Achievement,
    animatedNumber: Int,
) {
    Row(
        modifier = modifier, verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            modifier = Modifier.size(70.px), src = achievement.icon
        )

        Column(
            modifier = Modifier.margin(left = 10.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            P(
                attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY).fontSize(30.px).fontWeight(FontWeight.Bolder)
                    .color(Theme.Primary.rgb).toAttrs()
            ) {
                Text(
                    if (achievement == Achievement.Completed) "$animatedNumber+"
                    else animatedNumber.toString()
                )
            }

            P(
                attrs = Modifier.fillMaxWidth().margin(topBottom = 0.px)
                    .fontFamily(Constants.FONT_FAMILY).fontSize(16.px).fontWeight(FontWeight.Normal)
                    .color(Theme.Secondary.rgb).opacity(50.percent).toAttrs()
            ) {
                Text(achievement.description)
            }
        }
    }
}